import dynamic from 'next/dynamic';
import { dispensaryService, stateService } from '../../../../services';
import { serverLocationDetector } from '../../../../utils/locationDetector';
const InState = dynamic(() => import('../../../../templates/InState'))
const Error404 = dynamic(() => import('../../../../templates/Error404'))
const Layout = dynamic(() => import('../../../../components/_App/Layout'))
const InternalServerError = dynamic(() => import('../../../../templates/InternalServerError'))

const validBusinesses = [
    'dispensaries',
    'deliveries'
]

const StatePage = (props) => {
   
    if(props.code === 500){
        return <InternalServerError isAppleMobile={props.isAppleMobile} />
    }

    
    return (
        <Layout
            isAppleMobile = {props.isAppleMobile}
            seo={{
                description:`Discover the weed ${props.business === 'dispensaries' ? 'deliveries or storefronts that are located in' : ' delivery services offering that are located in'} ${props.data.name}`,
                url: props.url,
                title: `Weed ${props.business === 'dispensaries' ? 'Dispensaries' : 'Deliveries'} in ${props.data.name} | Weedzly`
            }}
        >
            <InState {...props} />
        </Layout>
    );
    
}

export default StatePage;

export async function getServerSideProps(context){
    let isAppleMobile = (context.req
        ? context.req.headers['user-agent']
        : navigator.userAgent).match(
          /iPhone|iPad|iPod/i
        )

    try {
        const state = await stateService.findByAbr(context.query.region)
        await serverLocationDetector(context)

        let inf = state.information

        let i = 0
        let c = 0
        let h1f = (inf && inf.includes('<h1>')) ? inf.match(new RegExp('<h1>', "g")).length : 0
        let h2f = (inf && inf.includes('<h2>')) ? inf.match(new RegExp('<h2>', "g")).length : 0
        let h3f = (inf && inf.includes('<h3>')) ? inf.match(new RegExp('<h3>', "g")).length : 0
        let h4f = (inf && inf.includes('<h4>')) ? inf.match(new RegExp('<h4>', "g")).length : 0
        let h5f = (inf && inf.includes('<h5>')) ? inf.match(new RegExp('<h5>', "g")).length : 0
        let h6f = (inf && inf.includes('<h6>')) ? inf.match(new RegExp('<h6>', "g")).length : 0

        for(i = 0; i < h1f; i++){
            inf = inf.replace('<h1>', `<h1 id="${c}">`)
            c = c + 1
        }
        for(i = 0; i < h2f; i++){
            inf = inf.replace('<h2>', `<h2 id="${c}">`)
            c = c + 1
        }
        for(i = 0; i < h3f; i++){
            inf = inf.replace('<h3>', `<h3 id="${c}">`)
            c = c + 1
        }
        for(i = 0; i < h4f; i++){
            inf = inf.replace('<h4>', `<h4 id="${c}">`)
            c = c + 1
        }
        for(i = 0; i < h5f; i++){
            inf = inf.replace('<h5>', `<h5 id="${c}">`)
            c = c + 1
        }
        for(i = 0; i < h6f; i++){
            inf = inf.replace('<h6>', `<h6 id="${c}">`)
            c = c + 1
        }

        if(inf){
            state.information = inf
        }

        if(!validBusinesses.includes(context.query.business)){
            return {
                notFound: true,
            }
        }    

        return {
            props: {
                data: state,
                business: context.query.business,
                isAppleMobile,
                url: context.req.url.split("?")[0].split("#")[0],
            }
        } 
    } catch({message, code}) {
        if(code === 404){
            return {
                notFound: true,
            }
        }
        return {
            props: {
                isAppleMobile,
                success: false,
                code: code,
                message,
            }
        }
    }
}